import React, { useState } from 'react';
import classNames from 'classnames';
import ReturnRegularIcon from 'src/monet/icons/ReturnRegularIcon';
import LoadingSpinner from 'src/common/components/loading-spinner';

type Props = {
  placeholder?: string;
  autoFocus?: boolean;
  loading?: boolean;
  onSubmit: (value: string) => void;
}

export const CmdkAiTextInput = ({
  placeholder = '',
  loading = false,
  autoFocus = true,
  onSubmit,
}: Props) => {
  const [textInputValue, setTextInputValue] = useState('');
  return (
    <div className="relative">
      <input
        type='text'
        placeholder={placeholder}
        value={textInputValue}
        onChange={(e) => setTextInputValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e && e.preventDefault();
            onSubmit(textInputValue);
          }
        }}
        autoFocus={autoFocus}
        disabled={loading}
        className={classNames(
          'w-full py-[8px] px-4 text-bedrock-p bg-bedrock-black text-white disabled:opacity-50 border-none transition placeholder:text-white/40',
          'focus:outline-none focus:ring-0 ring-transparent outline-none',
          'disabled:opacity-40',
          'pr-8',
        )}
      />
      <button type="button" className="absolute right-4 top-[11px] has-hover" onClick={() => onSubmit(textInputValue)}>
        {loading ? 
          <LoadingSpinner /> :
          <ReturnRegularIcon className="w-4 h-4 text-white" />
        }
      </button>      
    </div>
  )
}